import { styled } from '@mui/material/styles';
import { Box, Stack, Card, CardContent, CardActions, Typography, TextField, Checkbox, FormControl, IconButton, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

// Global dialog styles using a style tag (for MuiDialog override)
export const dialogStyles = `
  .MuiDialog-container .MuiDialog-paper {
    max-width: 80vw !important;
    width: 75vw !important;
    min-width: 1000px !important;
    height: 95vh !important;
    max-height: 95vh !important;
  }
  .MuiDialog-container .MuiDialog-paper .MuiDialogActions-root {
    padding: 1px 8px !important;
    min-height: 24px !important;
    margin: 0 !important;
  }
`;

// Close button
export const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: 8,
  top: 8,
  color: theme.palette.grey[500],
}));

// Main container
export const StyledMainContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  height: '100%',
  overflow: 'auto',
  width: '100%',
  transform: 'scale(0.95)',
  transformOrigin: 'top center',
});

// Form row containers
export const StyledFormRow = styled(Stack)({
  justifyContent: 'flex-start',
});

// Form field containers
export const StyledFieldContainer = styled(Box)({
  flex: 1,
});

export const StyledRightFieldContainer = styled(Box)({
  flex: 1,
  padding: '8px',
});

export const StyledPaddedFieldContainer = styled(Box)({
  flex: 1,
  padding: '9px',
});

// Package ID field
export const StyledPackageIdField = styled(TextField)({
  marginTop: '4px',
});

// Checkbox containers
export const StyledCheckbox = styled(Checkbox)({
  marginLeft: '21px',
});

// Form control for select
export const StyledFormControl = styled(FormControl)({
  flex: 1,
});

export const StyledInputLabel = styled('label')({
  marginTop: '10px',
});

export const StyledSelect = styled('select')({
  marginTop: '4px',
});

// Card container for data grid
export const StyledCard = styled(Card)({
  marginTop: 8,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  minHeight: '300px',
});

export const StyledCardContent = styled(CardContent)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  paddingBottom: 0,
  height: '100%',
});

// Data grid container
export const StyledDataGridContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-start',
  overflow: 'hidden',
  width: '100%',
});

// Data grid styles object
export const dataGridStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  '& .MuiTableContainer-root': {
    width: '100%',
    overflow: 'auto',
  },
  '& .MuiTable-root': {
    width: '100%',
    height: 'auto',
    maxHeight: 'none !important',
    tableLayout: 'fixed',
    fontSize: '0.875rem',
  },
  '& .MuiTableCell-root': {
    alignContent: 'center',
    padding: '2px 8px',
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    fontWeight: 600,
    fontSize: '0.8rem',
    padding: '4px 8px', 
  },
};

// Card actions container
export const StyledCardActions = styled(CardActions)({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 0,
  paddingTop: 4,
  paddingBottom: 4,
  flexShrink: 0,
  minHeight: '20px', 
});

export const StyledButtonContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  gap: 8,
});

// Warning typography
export const StyledWarningText = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.main,
  fontSize: '0.875rem',
}));

// Snackbar container
export const StyledSnackbar = styled(Snackbar)({
  anchorOrigin: { vertical: 'top', horizontal: 'center' },
});

export const StyledAlert = styled(MuiAlert)({
  width: '100%',
  fontSize: '1.2rem',
  padding: '12px 16px',
});

// Title styles for GenericDialog
export const titleSx = {
  color: '#143A6B',
  fontSize: '1.2rem',
};

// Container styles for GenericDialog
export const containerSx = {
  height: '100%',
  overflow: 'hidden',
  padding: '2px'
};
